var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluidMonitorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fluid_Monitor_Software-Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107 107",
    style: {
      enableBackground: "new 0 0 107 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:#0037A0;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12447.3701,
    y1: -1325.1104,
    x2: -12661.0742,
    y2: -1132.6901,
    gradientTransform: "matrix(-1 0 0 -1 -12488.4434 -1191.4556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2595,
    style: {
      stopColor: "#1D5FC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4363,
    style: {
      stopColor: "#428AC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    style: {
      stopColor: "#4997D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5878,
    style: {
      stopColor: "#51A1D7"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    className: "st0",
    width: 100,
    height: 80
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5554,
    y1: 115.7985,
    x2: 128.5847,
    y2: -14.2907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1175,
    style: {
      stopColor: "#48BCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1849,
    style: {
      stopColor: "#5CC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    style: {
      stopColor: "#7AD7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4279,
    style: {
      stopColor: "#90E3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5433,
    style: {
      stopColor: "#9EEBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6487,
    style: {
      stopColor: "#A2EDFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.5,104.07h84c4.72,0,8.57-3.84,8.57-8.57V69.16c-6.85,1.27-12.22,0.49-13.07-7.51 c-1.96-18.37-4.01-39.23-28.05-38.58c-15.13,0.41-27.84,10.6-36.95,21.89c-2.71,3.36-4.95,6.96-7.18,10.57 c-1.45,2.36-2.9,4.74-4.47,7.05c-2.77,4.1-6.62,8.67-11.41,9.74V95.5C2.93,100.22,6.78,104.07,11.5,104.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8456,
    y1: 108.9638,
    x2: 61.6555,
    y2: 20.9247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    style: {
      stopColor: "#103E93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3393,
    style: {
      stopColor: "#114095"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#16499D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5659,
    style: {
      stopColor: "#1E57AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    style: {
      stopColor: "#1F58AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7791,
    style: {
      stopColor: "#2D6CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    style: {
      stopColor: "#3676B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    style: {
      stopColor: "#4D8FC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#5DA1CC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.5,104.07h84c4.72,0,8.57-3.84,8.57-8.57V76.09c-4.66,0.7-9.36,0.6-12.62-2.83 c-2.84-2.99-3.01-7.27-3.12-11.16c-0.13-4.83-0.66-9.66-2.49-14.18c-2.71-6.7-7.88-12.16-14.91-14.25 c-6.72-2.01-14.03-1.57-20.66,0.57c-5.93,1.92-11.29,5.3-15.94,9.41c-4.98,4.4-8.41,10.23-11.92,15.96 c-4.09,6.69-8.29,13.25-15.17,17.24c-1.35,0.78-2.8,1.36-4.29,1.82V95.5C2.93,100.22,6.78,104.07,11.5,104.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.621,
    y1: 80.4011,
    x2: 70.1542,
    y2: 41.0834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    style: {
      stopColor: "#5EC4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    style: {
      stopColor: "#74D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8FE0FF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.36,50.39c-1.12,7.21-7.33,13.72-13.88,14.54c-6.55,0.82-10.96-4.36-9.84-11.57 c1.12-7.21,7.33-13.72,13.88-14.54C69.07,37.99,73.48,43.17,72.36,50.39z M37.95,48.43c-4.73,1.31-9.64,7.35-10.96,13.49 s1.45,10.07,6.18,8.76c4.73-1.31,9.64-7.35,10.96-13.49C45.45,51.05,42.68,47.12,37.95,48.43z M81.47,61.4 c-1.81-3.66-4.86-4.89-6.82-2.76c-1.95,2.14-2.07,6.83-0.25,10.49c1.81,3.66,4.86,4.89,6.82,2.76 C83.17,69.76,83.28,65.06,81.47,61.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4334,
    y1: 88.7841,
    x2: 102.7347,
    y2: 88.7841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841,
    style: {
      stopColor: "#001767"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    style: {
      stopColor: "#001C6B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.5,104.07h84c4.72,0,8.57-3.84,8.57-8.57v-6.55c-6.86,1.41-13.71-2.02-20.57-5.45 c-8.72-4.36-19.99-10-29.91-10H53.5c-10.26,0-20.96,5.48-30,10c-6.86,3.43-13.71,6.85-20.57,5.45v6.55 C2.93,100.22,6.78,104.07,11.5,104.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -11.0417,
    y1: 99.8272,
    x2: 249.8179,
    y2: -211.0532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1441,
    style: {
      stopColor: "#55A8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1609,
    style: {
      stopColor: "#5EB0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2252,
    style: {
      stopColor: "#7DCAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    style: {
      stopColor: "#93DDF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3481,
    style: {
      stopColor: "#A0E8F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4023,
    style: {
      stopColor: "#A5ECF2"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3.5,38.42c0,1.61-0.03,3.23,0.01,4.85c0,0,8.22,0.45,25.77-14.86c10.76-9.38,24.88-14.92,39.36-13.21 c0.07,0.01,0.15,0.02,0.22,0.03c0.76,0.09,1.53,0.21,2.28,0.34c3.84,0.67,7.6,1.91,11.02,3.81c3.67,2.03,6.64,4.91,9.65,7.79 c3.84,3.69,7.71,7.44,12.25,10.26V11.5c0-4.72-3.84-8.57-8.57-8.57h-84c-3.65,0-6.77,2.3-8,5.53c0,1.86,0,3.72,0,5.58 C3.5,22.17,3.5,30.29,3.5,38.42z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st6",
    d: "M95.5,3.5c4.42,0,8,3.58,8,8v84c0,4.42-3.58,8-8,8h-84c-4.42,0-8-3.58-8-8v-84 c0-4.42,3.58-8,8-8H95.5 M95.5,0h-84C5.16,0,0,5.16,0,11.5v84c0,6.34,5.16,11.5,11.5,11.5h84c6.34,0,11.5-5.16,11.5-11.5v-84 C107,5.16,101.84,0,95.5,0L95.5,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluidMonitorLogo);
export default __webpack_public_path__ + "static/media/fluid_monitor_logo.cc2e17bb331580ee6c7fb377488df910.svg";
export { ForwardRef as ReactComponent };